import React from 'react';
import { Column } from '../../components/column';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { Spacer } from '../../components/spacer';
import { ItemButton } from './item-button';
import { ItemDescription } from './item-description';
import { ItemImage } from './item-image';
import { ItemPrice } from './item-price';
import { ItemTitle } from './item-title';
import { itemGridColumn, itemGridSpacer } from './css-classes';
export const ItemsColumn = ({ section, item, padding, width }) => {
    var _a, _b, _c, _d;
    return (React.createElement(Column, { padding: padding, cssClass: `${itemGridColumn} ${mobileFullWidthColumnClassName}`, width: width }, item && (React.createElement(React.Fragment, null,
        React.createElement(ItemImage, { item: item, spaceForColumn: section.spaceForColumn }),
        ((_a = section.show) === null || _a === void 0 ? void 0 : _a.title) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemTitle, { section: section, item: item }),
        ((_b = section.show) === null || _b === void 0 ? void 0 : _b.description) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemDescription, { section: section, item: item }),
        ((_c = section.show) === null || _c === void 0 ? void 0 : _c.price) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemPrice, { section: section, item: item }),
        ((_d = section.show) === null || _d === void 0 ? void 0 : _d.button) !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemButton, { section: section, item: item })))));
};
//# sourceMappingURL=item-column.js.map